import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/lib/Overlay';
import { Helpers } from 'shared-components/helpers/helpers';
import { injectIntl } from 'react-intl';
import moment from 'moment';

export class TimeSelectorInputComponent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      show: false
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.onChangeDropdown = this.onChangeDropdown.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentDidUpdate (prevProps) {
    const { show } = this.state;
    const { selectedTimeIndex, hasError, validFn } = this.props;
    const isMobile = Helpers.isMobile();

    if (show && isMobile) {
      const whichBody = $('#fee-calc-modal');
      const divScrollHeight = $(this.dropdownList)[0].scrollHeight;
      whichBody.animate({
        scrollTop: (divScrollHeight)
      }, 1000);
    }

    if (hasError && (prevProps.selectedTimeIndex !== selectedTimeIndex)) {
      validFn();
    }
  }

  onChangeDropdown (event) {
    const { onChangeHandler } = this.props;
    const target = event.target;
    const value = target.getAttribute('data-value');
    onChangeHandler(value, () => {
      this.setState({ show: false });
    });
  }

  onKeyPress (event) {
    event.preventDefault();
    event.stopPropagation();

    if (13 === event.keyCode) {
      if (-1 !== event.target.tabIndex) {
        this.onChangeDropdown(event);
      }
    }
    if (40 === event.keyCode && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
    if (38 === event.keyCode && event.target.previousElementSibling) {
      event.target.previousElementSibling.focus();
    }
  }

  toggleDropdown () {
    const { show } = this.state;
    const toggle = () => {
      this.setState({ show: !show });
    };
    return toggle();
  }


  closeDropdown () {
    this.setState({ show: false });
  }

  render () {
    const {
      label,
      placeholder,
      selectedTimeIndex,
      selectDisabled,
      htmlId,
      hasError,
      inputRef,
      timeData,
      errorMessage,
      buttonStyle,
      intl
    } = this.props;
    const { show } = this.state;
    const disabledColor = selectDisabled ? { color: '#CED2DA' } : {};
    const parseTimeIndex = parseInt(selectedTimeIndex, 10);
    const selectedTime = _.filter(timeData, { time_index: parseTimeIndex })[0] || {};
    const dropdownValue = !_.isEmpty(selectedTime) ? intl.formatTime(moment(selectedTime.time, 'LT').format()) : placeholder;
    return (
      <div className="dropdown-container">
        { label ? <label className="time-label" htmlFor={`${htmlId}`}>{label} </label> : '' }
        <div>
          <button
            id={`${htmlId}`}
            type="button"
            className={`btn dropdown-btn btn-block text-gray-dark ${hasError ? 'border-error' : ''}`}
            style={{ ...disabledColor, ...buttonStyle }}
            onClick={this.toggleDropdown}
            disabled={selectDisabled}
            ref={(ref) => {
              if (inputRef) return inputRef(ref);
              this.target = ref;
              return this.target;
            }}
            aria-haspopup="listbox"
            aria-expanded={show}
            data-value={!_.isEmpty(selectedTime) ? selectedTimeIndex : ''}
          >
            <span className="dropdown-value ellipsis">
              {dropdownValue}
            </span>
            <span className="down-arrow" />
          </button>
          <Overlay
            show={show}
            rootClose
            onHide={() => this.setState({ show: false })}
            placement="bottom"
            animation={false}
            container={this}
            target={this.target}
          >
            <ul
              ref={ ref => { this.dropdownList = ref; }}
              className="time-dropdown dropdown-list"
              tabIndex={-1}
              role="listbox"
              aria-labelledby="dropdown-list"
            >
              {
                _.map(timeData, (value) => {
                  const { time_index: timeIndex, time } = value;
                  const formattedTime = intl.formatTime(moment(time, 'LT').format());
                  const rxKey = `${htmlId}-${timeIndex}`;
                  const selected = timeIndex === parseTimeIndex;
                  return (
                    <li
                      onClick={this.onChangeDropdown}
                      onKeyDown={this.onKeyPress}
                      role="option"
                      aria-label={formattedTime}
                      className={`${selected ? 'selected' : ''}`}
                      aria-selected={selected}
                      key={rxKey}
                      data-value={timeIndex}
                      tabIndex={0}
                    >
                      {formattedTime}
                    </li>
                  );
                })
              }
            </ul>
          </Overlay>
        </div>
        {
          hasError ?
            <p className="help-block inline-help text-danger text-left">{errorMessage}</p> : ''
        }
      </div>
    );
  }
}

TimeSelectorInputComponent.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  selectDisabled: PropTypes.bool,
  htmlId: PropTypes.string.isRequired,
  selectedTimeIndex: PropTypes.string,
  hasError: PropTypes.bool,
  inputRef: PropTypes.func,
  timeData: PropTypes.array,
  errorMessage: PropTypes.string,
  validFn: PropTypes.func,
  buttonStyle: PropTypes.object
};


export const TimeSelectorInput = injectIntl(TimeSelectorInputComponent);